module.exports = __webpack_public_path__ + "img/67800.8c7be0b0.jpg";